import Base from './Base'

export default class Edge extends Base {
    type = 'edge';
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'parent', 'position', 'type', 'name', 'price', 'originalPrice', 'new', 'delete', 'show'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}